import { Grid, Typography } from '@mui/material';

export const Philosophy = () => {
    return (
        <Grid container direction="column" spacing={2} my={1} px={2} pb={2} bgcolor="#1976d2">
            <Grid item container justifyContent="center">
                <Typography variant="h5" color="white">理念</Typography>
            </Grid>
            <Grid item container justifyContent="center">
                <Typography variant="h6" color="white">野球を通じ心身の鍛練と、</Typography>
                <Typography variant="h6" color="white">信頼・協調・感謝の心を育む。</Typography>
            </Grid>
        </Grid>
    )
}
